import React from "react";
import moment from "moment";
import { Link } from "react-router";
import { Table, Tr, Td, Sort } from "reactable";
import { RaisedButton } from "material-ui";

import * as util from "../../util";

class GeoAnalyticsTable extends React.Component {
  constructor(props) {
    super(props);
    this._makeRow = this._makeRow.bind(this);
  }

  _makeRow(data) {
    let noWrapTdStyle = { whiteSpace: "nowrap" };

    return (
      <Tr key={data.postal}>
        <Td column="Postal code" value={data.postal} style={noWrapTdStyle}>
          {`${data.postal}${
            data.city
              ? ` (${data.city}, ${data.region}, ${data.country_name})`
              : ""
          }`}
        </Td>
        <Td
          column="Total volume"
          value={data.total_volume}
          style={noWrapTdStyle}
        >
          {util.formatPrice(data.total_volume)}
        </Td>
        <Td
          column="Total tickets"
          value={data.total_tickets}
          style={noWrapTdStyle}
        >
          {util.formatNumber(data.total_tickets)}
        </Td>
        <Td
          column="Total passes"
          value={data.total_passes}
          style={noWrapTdStyle}
        >
          {util.formatNumber(data.total_passes)}
        </Td>
        <Td
          column="Total unique customers"
          value={data.total_people}
          style={noWrapTdStyle}
        >
          {util.formatNumber(data.total_people)}
        </Td>
      </Tr>
    );
  }

  downloadCsv(data) {
    util.clientSideDownload(
      `geo-analytics-${util.snakeCase(this.props.eventBucket.name)}.csv`,
      "text/csv",
      util.makeCsv(
        [
          [
            "Postal code",
            "City",
            "Region",
            "Country",
            "Total volume",
            "Total tickets",
            "Total passes",
            "Total unique customers"
          ]
        ].concat(
          data.map(d => {
            return [
              d.postal,
              d.city,
              d.region,
              d.country_name,
              d.total_volume / 100,
              d.total_tickets,
              d.total_passes,
              d.total_people
            ];
          })
        )
      )
    );
  }

  render() {
    const { data } = this.props,
      rows = data.map(this._makeRow);

    return (
      <div>
        <Table
          className="bordered striped responsive-table"
          sortable={[
            "Postal code",
            "Total volume",
            "Total tickets",
            "Total passes",
            "Total unique customers"
          ]}
          defaultSort={{ column: "Total volume", direction: "desc" }}
          columns={[
            "Postal code",
            "Total volume",
            "Total tickets",
            "Total passes",
            "Total unique customers"
          ]}
        >
          {rows}
        </Table>
        {rows.length === 0 ? (
          <div className="empty-table-message">
            No web orders with geo data yet.
          </div>
        ) : null}
        <RaisedButton
          style={{ marginTop: "1em" }}
          label="Download (.csv)"
          onTouchTap={() => this.downloadCsv(data)}
        />
      </div>
    );
  }
}

export default GeoAnalyticsTable;



// WEBPACK FOOTER //
// ./src/app/components/partials/geo-analytics-table.jsx